import PropTypes from "prop-types"
import React from "react"
import Micromap from "./micromap"

const BOUNDS = [
  [-1.540491040528505, -0.8127940686351808],
  [-1.5275931620760224, -0.7967593627466172],
]

const PATH =
  "M25.057056451194512,0L139.80811045045994,0.4184481717966264L338.31625963861006,1.6323705715767574L351.2009116123663,26.01533815348739L368.66432049158175,51.002875733422115L388.34559536010056,66.28532585961875L406.4196357764158,145.56882577754732L416.7435537854908,165.45800395296828L418.0301250454795,188.6782829174481L427.30649975454435,221.93231610430303L433.0536201037248,229.628828906556L431.51561232845415,250.7835286997797L437.31759155369946,254.52119569653587L436.87284280850145,275.0563796801762L455.19244200336834,307.86760957633305L458.3886246157417,330.2101570050181L487.2352502774811,356.7692917608838L491.31178723425546,391.1416421848335L490.7207481528894,599.3620002086318L370.41653911622416,600L317.9747190118069,599.6330638416512L317.7696513084302,539.3394947934066L316.1878870487053,522.3891919411908L239.8798435305871,523.885987211579L238.24322039479011,447.83517880658474L162.7221405153905,450.01210587440073L161.77909031263698,411.63744018851503L202.68421939793188,410.46472882369926L236.84235980966332,384.0560716725813L232.62410408973665,243.85038238394918L232.76647593476082,140.98733902923777L160.44745640445763,142.29398848201163L86.21360086691857,146.06965600465628L9.281211092689773,147.69073362295967L8.68821276575909,76.66015317538404L25.377719643402088,76.84665719702389Z"

const Cook = ({ style, points }) => (
  <Micromap style={style} path={PATH} bounds={BOUNDS} points={points} />
)

Cook.propTypes = {
  style: PropTypes.object,
  points: PropTypes.array,
}

Cook.defaultProps = {
  style: {},
  points: [],
}

export default Cook
